import { Col, Row, Typography } from "antd";
import PriceFormatter from "apps/Common/PriceFormatter";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";

const PackageInfoes = () => {
  const { Text } = Typography;
  const { selectedPackages } = useSelector((state: RootState) => state.ad);

  const packagePrice =
    selectedPackages?.package?.priceWithDiscount &&
    selectedPackages?.package?.priceWithDiscount > 0
      ? selectedPackages?.package?.priceWithDiscount
      : selectedPackages?.package?.price || 0;

  const dopingTotalPrice = selectedPackages?.dopings?.length
    ? selectedPackages.dopings.reduce(
        (total: number, item: any) =>
          total +
          (item?.priceWithDiscount && item?.priceWithDiscount > 0
            ? item?.priceWithDiscount || 0
            : item?.price || 0),
        0
      )
    : 0; // Eğer doping listesi boşsa, toplam 0 olmalı.

  const totalPrice = (packagePrice || 0) + (dopingTotalPrice || 0);

  return (
    <Col
      xs={24}
      className="relative col-span-full flex flex-col  pl-8 pr-4  !rounded-md !w-full "
    >
      <div className="relative">
        <ul>
          <div className="!flex !mt-4 justify-center">
            <Text className="!text-2xl !font-bold !text-black">
              Seçilen Paketler
              <span className="mt-2 block h-1 w-10 bg-black sm:w-20"></span>
            </Text>
          </div>
          <li className="flex justify-between">
            <div className="inline-flex">
              <Col xs={24} lg={20} className="ml-3">
                <p className="text-base font-semibold !text-black">
                  {selectedPackages?.package?.name}
                </p>
                <p className="text-sm font-medium !text-black text-opacity-80">
                  {selectedPackages?.package?.description}
                </p>
              </Col>
            </div>
            <Col xs={24} lg={4} className="!flex justify-end items-center">
              <p className="text-sm font-semibold !text-black">
                {selectedPackages?.package?.priceWithDiscount > 0 &&
                selectedPackages?.package?.priceWithDiscount !==
                  selectedPackages?.package?.price ? (
                  <>
                    <div>
                    <Text
                              className={`  
                  !text-red-500  !line-through !font-normal
                  `}
                            >
                              <PriceFormatter
                                classNames="!text-red-500  !line-through !font-normal"
                               
                                inputPrice={selectedPackages?.package?.price}
                              />
                            </Text>
                     
                    </div>
                    <div>
                      <Text className="text-xl !text-black">
                        <PriceFormatter
                          inputPrice={
                            selectedPackages?.package?.priceWithDiscount
                          }
                        />
                      </Text>
                    </div>
                  </>
                ) : (
                  <Text className="text-2xl font-bold !text-black">
                    <PriceFormatter
                      inputPrice={selectedPackages?.package?.price}
                    />
                  </Text>
                )}
              </p>
            </Col>
          </li>
        </ul>
        {selectedPackages?.dopings?.length > 0 && (
          <>
            <div className="my-5 h-0.5 w-full bg-black bg-opacity-30"></div>
            <div className="mt-4">
              <div className="!flex justify-center ">
                <p className="!font-bold !text-2xl">
                  Seçilen Dopingler
                  <span className="mt-2 my-8 block h-1 w-10 bg-black sm:w-20"></span>
                </p>
              </div>
              {selectedPackages?.dopings?.map((item: any, index: number) => (
                <div key={index} className="!inline-flex !mb-8 ">
                  <Col xs={24} lg={20} className="ml-3 !flex !flex-col">
                    <p className="text-base font-semibold !text-black">
                      {index + 1}.{item?.name}
                    </p>
                    <p className="text-sm font-medium !text-black text-opacity-80">
                      {item?.description}
                    </p>
                  </Col>
                  <Col
                    xs={24}
                    lg={4}
                    className="!flex justify-end items-center"
                  >
                    <p className="text-sm font-semibold !text-black">
                      {item?.priceWithDiscount > 0 &&
                      item?.priceWithDiscount !== item?.price ? (
                        <>
                          <div>
                            <Text
                              className={`  
                  !text-red-500  !line-through !font-normal
                  `}
                            >
                              <PriceFormatter
                                classNames="!text-red-500  !line-through !font-normal"
                                inputPrice={item?.price}
                              />
                            </Text>
                          </div>
                          <div>
                            <Text className="text-xl !text-black">
                              <PriceFormatter
                                inputPrice={item?.priceWithDiscount}
                              />
                            </Text>
                          </div>
                        </>
                      ) : (
                        <Text className="text-2xl font-bold !text-black">
                          <PriceFormatter inputPrice={item?.price} />
                        </Text>
                      )}
                    </p>
                  </Col>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      <div className="relative  !text-black ">
        <div className="my-5 h-[1px] w-full bg-black bg-opacity-30"></div>
        <Row className="!w-full">
          <Col xs={24} lg={17}></Col>
          <Col xs={24} lg={7}>
            <div className="">
              <div>
                <Text className="!font-bold">Paket Fiyatı:</Text>
              </div>
              <div className="!flex justify-end">
                <Text>
                  <PriceFormatter inputPrice={packagePrice} />
                </Text>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={24} lg={17}></Col>
          <Col xs={24} lg={7}>
            {selectedPackages?.dopings?.map((item: any, index: number) => (
              <div key={index} className="">
                <div>
                  <Text className="!font-bold">
                    {" "}
                    {index + 1}. Doping Fiyatı:{" "}
                  </Text>
                </div>
                <div className="!flex justify-end items-center">
                  <Text>
                    {item?.priceWithDiscount > 0 ? (
                      <PriceFormatter inputPrice={item?.priceWithDiscount} />
                    ) : (
                      <PriceFormatter inputPrice={item?.price} />
                    )}
                  </Text>
                </div>
              </div>
            ))}
          </Col>
        </Row>
        <div className="!flex justify-end">
          <div className="my-1 !h-[1px] w-[220px] bg-black"></div>
        </div>
        <Row>
          <Col xs={24} lg={17}></Col>
          <Col xs={24} lg={7}>
            <div>
              <div>
                <Text className="!font-bold"> Toplam Ödenecek Tutar:</Text>
              </div>
              <div className="!flex justify-end">
                <PriceFormatter inputPrice={totalPrice || 0} />{" "}
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="relative  !text-black">
        <div className="my-5 h-[1px] w-full bg-black bg-opacity-30"></div>
        <div className="!flex justify-center">
          <p className="!font-bold !text-2xl">
            Destek
            <span className="mt-2 my-8  block h-1 w-10 bg-black sm:w-20"></span>
          </p>
        </div>
        <div>
          <Text className="!text-sm !font-bold">352-653-743</Text>
        </div>
        <div>
          <Text className="mt-1 !text-sm !font-bold">
            support@sariilanlar.com
          </Text>
        </div>
        <div>
          <Text className="mt-2 !text-xs !font-bold">
            Ödeme problemleriniz için bize ulaşın
          </Text>
        </div>
      </div>
    </Col>
  );
};

export default PackageInfoes;
